import { PatientVaccine, PatientVaccineControllerApi } from "../../services";
import { getConfigObject, useMutationWithLoading } from "../../utils/utils";

/**
 * @author Rajkumar Rathod
 */
export const usePatientVaccineUpdate = () =>
  useMutationWithLoading(
    async (params: { patientVaccine: PatientVaccine; xTENANTID?: string }) =>
      new PatientVaccineControllerApi(getConfigObject()).updatePatientVaccine(
        params.patientVaccine,
        params.xTENANTID
      )
  );
